module.exports = __webpack_public_path__ + "img/story-2mobile.3892de44.jpg";